module.exports = {
  // COMMON
  form_send_error: 'Beim Versenden des Formulars ist ein Fehler aufgetreten. Bitte kontrollieren Sie Ihre Eingabe versuchen Sie es nochmal.',
  cookiePolicyBar: {
    text: 'Wir verwenden Cookies, um Ihren Besuch bestmöglich zu gestalten. Mit der Nutzung dieser Website, stimmen Sie der Verwendung von Cookies zu. Mehr dazu, in unserer <a href="/de/datenschutz">Datenschutzerklärung</a>.',
  },
  hint: {
    delete: {
      really: {
        jobs: {
          title: 'Job löschen?',
          message: 'Soll dieser Job wirklich unwiderruflich gelöscht werden?',
        },
      },
    },
  },

  // SPECIAL
  mylivecom_jobs: {
    controller: {
      title: 'Meine Jobs',
    },
    showEditModal: {
      title: 'Job bearbeiten',
    },
    showInsertModal: {
      title: 'Neuen Job anlegen',
    },
  },
  mylivecom_members: {
    showEditModal: {
      title: 'Mitgliedsdaten bearbeiten',
    },
  },

  // USER COMMUNICATION
  mails: {
    userEmailConfirmation: {
      confirm: {
        subject: 'MyLivecom: E-Mail-Adresse bestätigen',
        content: 'Bitte bestätigen Sie mit dem folgenden Link Ihre E-Mail-Adresse: \n\n{{-activationUrl}}',
      },
      sendPassword: {
        subject: 'MyLivecom: Zugangsdaten abrufen',
        content: 'Mit dem folgenden Link können Sie Ihre Zugangsdaten abrufen: \n\n{{-activationUrl}}',
      },
    },
  },
}